// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z1ph","left":"styles_left__3XiQl"};